import React from 'react';
import Popover from '@mui/material/Popover';
import imgFiltros from './../general/buscador/filtros.svg';
import { useState } from 'react';
import { FilterList } from '../general/buscadorPptos/filterList/FilterList';

import '../../assets/style/componentPrincipal.css'

const PptoBuscar = ({ filters, setFilters }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div>
            <img aria-describedby={id} variant="contained" className='p-buscar-filtros' src={imgFiltros} alt="filtros" onClick={handleClick} />
            <Popover
                className='p-popover-buscar-filtros'
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <FilterList
                    filters={filters}
                    setFilters={setFilters}
                />
            </Popover>
        </div>
    );
}

export default PptoBuscar